import { useQuery } from "react-query";

import { getClinicianSessionUtilization } from "api/clinician";
import { GET_CLINICIAN_SESSION_UTILIZATION, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { queryParamsObjIsValid } from "utils/queryParamsObjIsValid";

export interface SessionUtilizationRow {
  video_call_id: number;
  client_id: number;
  client_name: string;
  client_last_name: string;
  session_date: string;
  scheduled_minutes: number;
  delivered_minutes: number;
  billable_minutes: number;
  billable_units_lost: number;
}

interface Query {
  startDate: string;
  endDate: string;
  clientId?: string;
}

const useGetClinicianSessionUtilization = (
  clinicianId: string | number | undefined,
  query: Query
) => {
  const { data, isLoading, ...rest } = useQuery(
    [GET_CLINICIAN_SESSION_UTILIZATION, clinicianId, query],
    () => getClinicianSessionUtilization(clinicianId, query),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicianId && queryParamsObjIsValid(query),
      staleTime: STALE_TIME_5_MINUTES,
    }
  );

  return {
    sessionUtilization: data?.data ?? [],
    isSessionUtilizationLoading: isLoading,
    ...rest,
  };
};

export default useGetClinicianSessionUtilization;
